import { render, staticRenderFns } from "./ReportsViewList.vue?vue&type=template&id=28f20eae&scoped=true&"
import script from "./ReportsViewList.vue?vue&type=script&lang=js&"
export * from "./ReportsViewList.vue?vue&type=script&lang=js&"
import style0 from "./ReportsViewList.vue?vue&type=style&index=0&id=28f20eae&prod&lang=scss&scoped=true&"
import style1 from "./ReportsViewList.vue?vue&type=style&index=1&id=28f20eae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f20eae",
  null
  
)

export default component.exports